import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks';
import { Button } from '../components/common';
import './HomePage.css';

export const HomePage: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Your AI-Powered
            <span className="hero-highlight"> Health Assistant</span>
          </h1>
          <p className="hero-subtitle">
            Get personalized health insights, wellness guidance, and answers to your
            health questions powered by advanced AI and medical knowledge base.
          </p>
          <div className="hero-actions">
            {isAuthenticated ? (
              <Link to="/chat">
                <Button variant="primary" size="lg">
                  Start Chatting
                </Button>
              </Link>
            ) : (
              <>
                <Link to="/signup">
                  <Button variant="primary" size="lg">
                    Get Started Free
                  </Button>
                </Link>
                <Link to="/login">
                  <Button variant="outline" size="lg">
                    Sign In
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-illustration">
            <span className="illustration-emoji">🏋️</span>
            <span className="illustration-emoji">🧘</span>
            <span className="illustration-emoji">🥗</span>
            <span className="illustration-emoji">❤️</span>
          </div>
        </div>
      </section>

      <section className="features">
        <h2 className="features-title">Why Choose ElevatePhysique AI?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">🤖</span>
            <h3>AI-Powered Insights</h3>
            <p>
              Advanced AI analyzes your questions and provides accurate,
              evidence-based health information.
            </p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📚</span>
            <h3>Medical Knowledge Base</h3>
            <p>
              Access information from comprehensive health datasets covering
              various conditions and wellness topics.
            </p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">💬</span>
            <h3>Conversational Interface</h3>
            <p>
              Natural chat experience that remembers context and provides
              personalized follow-up responses.
            </p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔒</span>
            <h3>Secure & Private</h3>
            <p>
              Your health conversations are encrypted and protected with
              enterprise-grade security.
            </p>
          </div>
        </div>
      </section>

      <section className="cta">
        <h2>Ready to Transform Your Health Journey?</h2>
        <p>
          Join thousands of users who trust ElevatePhysique AI for their health
          and wellness guidance.
        </p>
        <Link to={isAuthenticated ? '/chat' : '/signup'}>
          <Button variant="primary" size="lg">
            {isAuthenticated ? 'Go to Chat' : 'Start Free Today'}
          </Button>
        </Link>
      </section>
    </div>
  );
};
